import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, OverlayTrigger, Row, Spinner, Tab, Table, Tabs, Tooltip } from 'react-bootstrap';
import { UsersCard } from '../../component/Card/Statistics.card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faInfo, faRefresh, faUser, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { ClientService } from '../../component/services/client.service';
import toast from 'react-hot-toast';
import { makeParams } from '../../component/api/makeRequest';
import DataTable from '../../component/table/Invigilator.table';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import moment from 'moment';
import TablePaginationComponent from '../../component/table/TablePagination';
import StatsCard from '../../component/Cards/StatsCard';
import { FaInfoCircle } from 'react-icons/fa';

export default function VerificationData() {
    const [tableData, setTableData] = useState<any[]>([]);
    const [centers, setCenters] = useState<any>([]);
    const [selectedCenters, setSelectedCenters] = useState<any>([]);
    const [shifts, setShifts] = useState<any>([]);
    const [selectedShift, setSelectedShift] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);


    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<any>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [stats, setStats] = useState<any>(null);


    const getUniqueCenter = async () => {
        try {
            const res = await ClientService.getUniqueCenter2(selectedShift);
            if (res.status === 200) {
                setCenters(
                    res.data?.centers.map((zone: any) => ({
                        value: zone?.centerPreference,
                        label: zone?.allocatedCenterId + " - " + zone?.centerPreference,
                    }))
                );
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch centers');
        }
    };

    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getStats = async () => {
        const payload = {
            centerId: selectedCenters?.map((data: any) => data?.value),
        }
        setLoading(true);
        try {
            const res = await ClientService.getVerificationDataV2(selectedShift, pageNumber, pageSize, payload);
            if (res.status === 200) {
                setTableData(res.data?.data?.verification || []);
                setTotalCount(res.data?.data?.total_count || 0);
                setStats({
                    total: res.data?.data?.total_count || 0,
                    distinct: res.data?.data?.distinct_students_verified || 0,
                });
            }
        } catch (err: any) {
            toast.error(err.response?.data || 'Failed to fetch stats');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedShift) {
            getStats();
        }
    }, [selectedCenters, pageNumber, pageSize]);

    useEffect(() => {
        if (selectedShift) {
            getUniqueCenter();
        }
    }, [selectedShift]);

    useEffect(() => {
        getAllShift();
    }, []);

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 className="text-secondary">Verification Data</h4>
                </Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectedShift(e?.value)}
                        isClearable
                        value={selectedShift ? shifts.find((shift: any) => shift.value === selectedShift.value) : null}
                    />
                </Col>
            </Row>
            <Card className="mt-3" style={{ backgroundColor: '#f9f9f9', borderRadius: '12px', border: 'none' }}>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="text-muted fw-bold">Venue</Form.Label>
                                <Select
                                    options={[{ label: 'All', value: 'All' }, ...(centers || [])]}
                                    onChange={(selectedOptions: any) => {
                                        if (selectedOptions?.some((option: any) => option.value === 'All')) {
                                            setSelectedCenters(centers);
                                        } else {
                                            setSelectedCenters(selectedOptions || []);
                                        }
                                    }}
                                    value={selectedCenters}
                                    // isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Row className="mt-4">
                <Card
                    className="mt-3"
                    style={{
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        border: "none",
                    }}
                >
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-end">
                            <Button size="sm" onClick={getStats} disabled={loading || !selectedShift || !selectedCenters.length} variant='outline-secondary'>
                                <FontAwesomeIcon icon={faRefresh} /> Reload
                            </Button>
                        </div>
                        <Row className="mt-3">
                            <Col md={3}>
                                <StatsCard
                                    title="Total Verifications"
                                    value={stats?.total || 0}
                                    icon={faUser}
                                    iconColor="success"
                                    valueColor="success"
                                />
                            </Col>
                            <Col md={3}>
                                <StatsCard
                                    title="Distinct Students Verified"
                                    value={stats?.distinct || 0}
                                    icon={faUserCheck}
                                    iconColor="success"
                                    valueColor="success"
                                />
                            </Col>
                        </Row>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th style={{ fontSize: 14 }}>#</th>
                                    <th style={{ fontSize: 14 }}>Student(Image/Name/Roll No/VenueId)</th>
                                    <th style={{ fontSize: 14 }}>Ver.Image/ID/EXAM</th>
                                    <th style={{ fontSize: 14 }}>State/Zone/City</th>
                                    <th style={{ fontSize: 14 }}>Facial</th>
                                    {/* <th style={{ fontSize: 14 }}>Fingerprint 1</th> */}
                                    <th style={{ fontSize: 14 }}>Fingerprint 2</th>
                                    {/* <th style={{ fontSize: 14 }}>GPS</th> */}

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ? (
                                        <tr>
                                            <td colSpan={14} className="text-center">
                                                <Spinner animation="border" size="sm" />
                                            </td>
                                        </tr>
                                    ) :
                                        tableData?.length > 0 ? (
                                            tableData.map((item: any, index: number) => {
                                                const facialVerification = item?.verificationDetails?.find((detail: any) => detail?.method === 'facial');
                                                const fingerprint1 = item?.verificationDetails?.find((detail: any) => detail?.method === 'fingerprint');
                                                const fingerprint2 = item?.verificationDetails?.find((detail: any) => detail?.method === 'fingerprint2');
                                                const gpsVerification = item?.verificationDetails?.find((detail: any) => detail?.method === 'gps');

                                                let facial = "Not Available";
                                                let facial_bypass = undefined;
                                                if(!facial){
                                                    facial = "Not Available";
                                                }
                                                else {
                                                    if(facialVerification?.success) {
                                                        facial = "Verified";
                                                            if(facialVerification.manuallyVerified){
                                                            facial = "Bypassed";
                                                            facial_bypass = facialVerification?.bypassReason || "-";
                                                            }
                                                    }
                                                }

                                                let finger1 = "Not Available";
                                                let finger1_bypass = undefined;
                                                if(fingerprint1?.success) {
                                                    finger1 = "Verified";
                                                    if(fingerprint1.manuallyVerified){
                                                        finger1 = "Bypassed";
                                                        finger1_bypass = fingerprint1?.bypassReason || "-";
                                                    }
                                                }

                                                let finger2 = "Not Available";
                                                let finger2_bypass = undefined;
                                                if(fingerprint2?.success) {
                                                    finger2 = "Verified";
                                                    if(fingerprint2.manuallyVerified){
                                                        finger2 = "Bypassed";
                                                        finger2_bypass = fingerprint2?.bypassReason || "-";
                                                    }
                                                }

                                                let gps = "Not Available";
                                                let gps_bypass = undefined;
                                                if(gpsVerification?.success) {
                                                    gps = "Verified";
                                                    if(gpsVerification.manuallyVerified){
                                                        gps = "Bypassed";
                                                        gps_bypass = gpsVerification?.bypassReason || "-";
                                                    }
                                                }

                                                return (
                                                    <tr key={item?._id}>
                                                        <td style={{ fontSize: 12 }}>
                                                            {index + 1 + (pageNumber - 1) * pageSize}
                                                        </td>
                                                        <td style={{ fontSize: 12 }} className='text-center'>
                                                            <div>
                                                            <img
                                                                src={item?.studentId?.avatar}
                                                                alt="Student"
                                                                style={{ width: 50, height: 50, borderRadius: '50%' }}
                                                            />
                                                            </div>
                                                            <div className='text-bold text-secondary'>
                                                            {item?.studentId?.name}
                                                            </div>
                                                            <div className='text-primary'>
                                                                {item?.studentId?.rollNo}
                                                            </div>
                                                            <div>
                                                                {item?.studentId?.centerPreference}
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: 12 }} className='text-center'>
                                                            <div>
                                                                <img
                                                                    src={item?.userLivePhoto}
                                                                    alt="Verification"
                                                                    style={{ width: 50, height: 50, borderRadius: '50%' }}
                                                                />
                                                            </div>
                                                            <div className="text-bold text-secondary">
                                                                {item?.verificationId}
                                                            </div>
                                                            <div className="text-primary">
                                                                {item?.studentId?.courseName}
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: 12 }}>
                                                            <div>
                                                                {item?.studentId?.state && <span className="text-secondary">State: {item?.studentId?.state}</span>}
                                                                <br />
                                                                {item?.studentId?.zone && <span className="text-secondary">Zone: {item?.studentId?.zone}</span>}
                                                                <br />
                                                                {item?.studentId?.city && <span className="text-secondary">City: {item?.studentId?.city}</span>}
                                                            </div>
                                                        </td>
                                                        <td style={{ fontSize: 12, width: '150px' }}>
                                                            { facial === "Not Available" && <span className="badge bg-secondary">Not Available</span> }
                                                            { facial === "Verified" && <span className="badge bg-success">Verified</span> }
                                                            { facial === "Bypassed" && (
                                                                    <span className="d-inline-flex align-items-center">
                                                                    <span className="badge bg-warning">Bypassed</span>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${index}`}>
                                                                                <span>{facial_bypass}</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span className='text-warning ms-1' style={{ cursor: 'pointer' }}>
                                                                            <FaInfoCircle />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </span>
                                                                )}
                                                        </td>
                                                        {/* <td style={{ fontSize: 12 }}>
                                                            { finger1 === "Not Available" && <span className="badge bg-secondary">Not Available</span> }
                                                            { finger1 === "Verified" && <span className="badge bg-success">Verified</span> }
                                                            { finger1 === "Bypassed" && (
                                                                <span className="d-inline-flex align-items-center">
                                                                    <span className="badge bg-warning">Bypassed</span>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${index}`}>
                                                                                <span>{finger1_bypass}</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span className='text-warning ms-1' style={{ cursor: 'pointer' }}>
                                                                            <FaInfoCircle />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            )}
                                                        </td> */}
                                                        <td style={{ fontSize: 12 }}>
                                                            { finger2 === "Not Available" && <span className="badge bg-secondary">Not Available</span> }
                                                            { finger2 === "Verified" && <span className="badge bg-success">Verified</span> }
                                                            { finger2 === "Bypassed" && (
                                                                <span className="d-inline-flex align-items-center">
                                                                    <span className="badge bg-warning">Bypassed</span>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${index}`}>
                                                                                <span>{finger2_bypass}</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span className='text-warning ms-1' style={{ cursor: 'pointer' }}>
                                                                            <FaInfoCircle />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            )}
                                                        </td>
                                                        {/* <td style={{ fontSize: 12 }}>
                                                            { gps === "Not Available" && <span className="badge bg-secondary">Not Available</span> }
                                                            { gps === "Verified" && <span className="badge bg-success">Verified</span> }
                                                            { gps === "Bypassed" && (
                                                                <span className="d-inline-flex align-items-center">
                                                                    <span className="badge bg-warning">Bypassed</span>
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 400 }}
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${index}`}>
                                                                                <span>{gps_bypass}</span>
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <span className='text-warning ms-1' style={{ cursor: 'pointer' }}>
                                                                            <FaInfoCircle />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            )}
                                                        </td> */}
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={14} className="text-center">
                                                    No Data Available
                                                </td>
                                            </tr>
                                        )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Row>

            <Row>
                <Col>
                    <TablePaginationComponent
                        currentPage={pageNumber}
                        itemsCount={totalCount}
                        itemsPerPage={pageSize}
                        setItemsPerPage={(e: any) => setPageSize(e)}
                        setCurrentPage={setPageNumber}
                    />
                </Col>
            </Row>
        </>
    );
};